import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { UserView } from './UserView';

export interface OutboundEmailRow {
  id: number;
  to_email_address: string;
  to_user_id: string;
  subject: string;
  template: string;
  status: string;
  error_message: string;
  created_at: string;
  body: string;
  instance_id: string;
}

export const OutboundEmail: Entity<OutboundEmailRow> = {
  id: 'OutboundEmail',
  title: 'Outbound Email',
  service: 'main',
  rowLabel: (row: OutboundEmailRow) => row.subject,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.outbound_email',
  },
  security: [{ role: 'staff', action: 'read', access: 'all' }],
  defaultSort: [['created_at', 'DESC']],
  defaultFilters: [{ fieldId: 'to_email_address', operator: 'sw', value: '' }],
  listRowLink: '/admin/outbound-email/display/{key}',
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      listColumn: true,
      autoIncrement: true,
    },
    to_email_address: {
      seq: 10,
      type: FieldType.Text,
      label: 'To Email Address',
      listColumn: true,
    },
    to_user_id: {
      seq: 15,
      type: FieldType.Reference,
      label: 'To User',
      refEntity: UserView,
      listColumn: true,
    },
    subject: {
      seq: 20,
      type: FieldType.Text,
      label: 'Subject',
    },
    template: {
      seq: 25,
      type: FieldType.Text,
      label: 'Template',
      listColumn: true,
    },
    status: {
      seq: 30,
      type: FieldType.Options,
      label: 'Status',
      listColumn: true,
      options: [
        { id: 'success', label: 'Success' },
        { id: 'failed', label: 'Failed' },
      ],
    },
    error_message: {
      seq: 35,
      type: FieldType.Text,
      label: 'Error Message',
    },
    created_at: {
      seq: 40,
      label: 'Created At',
      type: FieldType.Datetime,
      listColumn: true,
    },
    body: {
      seq: 45,
      type: FieldType.Richtext,
      label: 'Body',
      formColumnWidths: { lg: 12 },
    },
    instance_id: {
      seq: 50,
      type: FieldType.Text,
      label: 'Instance Id',
      description: 'Code which, along with toUserId and template avoids re-sending an email triggered by a cron',
    },
  },
};
